import React, { useEffect, useState } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import * as _ from "lodash";
import {
  setCurrentContract,
  setLoadChart,
  setTelemeter,
} from "../../../reducers/contracts";
import "./ContractsSelect.scss";
import { useTranslation } from "react-i18next";
import {
  Dropdown,
  DropdownIndicator,
  formatOptionLabel,
} from "./common/components";
import { Form, InputGroup } from "react-bootstrap";
import "../../CaseGenerator/FormFields/SelectSearch.scss";
import "../../CaseGenerator/FormFields/ContractSelectWithRemoteOptionsField.scss";

const ContractsSelect = (props) => {
  const [isKeyboard, setIsKeyboard] = useState(false);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowDown" || e.key === "ArrowUp") {
        setIsKeyboard(true);
      } else if (e.key === "Tab") {
        setIsKeyboard(false);
      }
    };

    const handleMouseMove = () => {
      setIsKeyboard(false);
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  const CustomMenuList = (props) => {
    const { innerRef, innerProps, children, selectProps } = props;

    return (
      <ul
        id={selectProps.menuId || "contract-list"}
        className="contract-list"
        role="listbox"
        ref={innerRef}
        {...innerProps}
      >
        {children}
      </ul>
    );
  };

  const CustomOption = (props) => {
    const { innerRef, innerProps, isFocused, data, children } = props;
    return (
      <li
        ref={innerRef}
        role="option"
        aria-selected={selectedContract.id === data.id}
        {...innerProps}
        className={[
          "custom-option",
          isFocused && isKeyboard ? "is-focused" : "",
        ]
          .join(" ")
          .trim()}
      >
        {children ?? data.label}
      </li>
    );
  };

  const options = useSelector((state) => {
    if (props.excludeInactives) {
      return (
        state.contracts.list &&
        state.contracts.list
          .filter((contract) => contract.state === "active")
          .map((contract) => {
            return {
              name: contract.name || "",
              id: contract.id || "",
              state: contract.state || "",
              clientId: contract.clientId || "",
              clientCode: contract.clientCode || "",
            };
          })
      );
    } else {
      return (
        state.contracts.list &&
        state.contracts.list.map((contract) => {
          return {
            name: contract.name || "",
            id: contract.id || "",
            state: contract.state || "",
            clientId: contract.clientId || "",
            clientCode: contract.clientCode || "",
          };
        })
      );
    }
  });
  let selectedContract = useSelector((state) => state.contracts.current);
  const [value, setValue] = useState(selectedContract);
  const [isOpen, setIsOpen] = useState(false);
  const { onUpdate, label } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const triggerUpdated = (selected) => {
    if (onUpdate) {
      onUpdate(selected);
    }
    setIsOpen(false);

    if (Number(selectedContract.id) !== Number(selected)) {
      dispatch(setTelemeter(null));
      dispatch(setLoadChart(false));
    }

    let [currentContract] = _.filter(options, (o) => {
      return o.id === selected ? o : null;
    });

    dispatch(setCurrentContract(currentContract));
    setValue(currentContract);
  };

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  const filterOption = (candidate, input) => {
    if (input) {
      return Object.values(candidate.data).some((item) => {
        if (!item) {
          return false;
        }
        return (
          item.indexOf(input) !== -1 || item.indexOf(input.toUpperCase()) !== -1
        );
      });
    }
    return true;
  };
  return (
    <Form.Group>
      {label && <Form.Label
              className="paragraph-small-fs9"
              htmlFor="contract-select"
              > {label} </Form.Label>}
      <div className="ContractsSelect" data-testid="ContractsSelect">
        <Dropdown
          isOpen={value ? isOpen : false}
          aria-expanded={isOpen}
          onClose={toggleOpen}
          target={
            <div
              className={`form-control select-remote-options dropdown ${isOpen}`}
            >
              <button
                onClick={toggleOpen}
                className="btn btn-contract-select btn-default  select-contracts"
                type="button"
                id={"contract-select-dropdown"}
              >
                {value && value.state ? (
                  <>
                    <span className={"font-bold badge badge--" + value.state}>
                      {t(`contract.select.state.${value.state}`)}
                    </span>
                    <span className="button-text">{value.name}</span>
                    <span className="gc-icon-functional-chevron-down contract-select-icon" />
                  </>
                ) : (
                  <>
                    <span className="button-text">
                      Nessun contratto disponibile
                    </span>
                  </>
                )}
              </button>
            </div>
          }
        >
          <Select
            autoFocus
            backspaceRemovesValue={false}
            value={value}
            formatOptionLabel={formatOptionLabel}
            options={options}
            components={{
              DropdownIndicator,
              IndicatorSeparator: null,
              MenuList: CustomMenuList,
              Option: CustomOption,
            }}
            controlShouldRenderValue={false}
            hideSelectedOptions={false}
            isClearable={false}
            menuIsOpen
            onChange={(data) => triggerUpdated(data.id)}
            className={"gcap-select form-control"}
            isDisabled={options.length <= 0}
            placeholder={
              options.length > 0
                ? "Scegli un contratto"
                : "Nessun contratto disponibile"
            }
            filterOption={filterOption}
            tabSelectsValue={false}
            id="contract-select"
          />
        </Dropdown>
      </div>
    </Form.Group>
  );
};

export default ContractsSelect;
